/**
 * Modifies input number to specified length by adding leading zeroes if needed.
 * @param {number} number input number to pad
 * @param {number} digits number of digits, default is 2
 * @returns {string} string representation of number padded with specified number of zeroes
 * @example
 * ```
 * lz(5, 2); // "05"
 * lz(5, 4); // "0005"
 * lz(5, 6); // "000005"
 * lz(1234, 2); // "1234"
 * ```
 */
export default function leadingZeros(number: number, digits: number = 2): string {
  if (!digits) {
    digits = 2;
  }

  return String(number).padStart(digits, '0');

  // NOTE: old implementation, if this one will not work on older LGs:

  // const numberStr = number.toString();
  // let repeat = Math.max(digits - numberStr.length, 0);
  // let out = '';
  // while (repeat--) {
  //   out += '0';
  // }
  // return out + numberStr;
}

// exports
window.lz = leadingZeros;

declare global {
  interface Window {

    lz: typeof leadingZeros;
  }

  const lz: typeof leadingZeros;
}
